// CSS
import '../sass/pages/home.scss'

// === WP ALPHA ASSETS
import '@nematis/wp-alpha/assets/js/home'

// === Slider overview #events : flèches prev/next ===
// Le track .cat-ov-track est un scroll horizontal natif (overflow-x:auto, 5 vignettes visibles).
// On injecte les deux flèches rondes (maquette .cat-ov-arrow) et on pilote le scroll au clic.
// Enrichissement progressif : sans JS, le scroll tactile/trackpad reste fonctionnel.
function initCatOvSlider() {
  document.querySelectorAll('.cat-ov-slider').forEach((slider) => {
    const track = slider.querySelector('.cat-ov-track')
    if (!track || slider.querySelector('.cat-ov-arrow')) {
      return
    } // idempotent

    const makeArrow = (dir) => {
      const isPrev = dir === 'prev'
      const btn = document.createElement('button')
      btn.type = 'button'
      btn.className = `cat-ov-arrow cat-ov-${dir}`
      btn.setAttribute('aria-label', isPrev ? 'Précédent' : 'Suivant')
      btn.innerHTML = `<i class="far fa-chevron-${isPrev ? 'left' : 'right'}" aria-hidden="true"></i>`
      btn.addEventListener('click', () => {
        track.scrollBy({
          left: (isPrev ? -1 : 1) * track.clientWidth * 0.8,
          behavior: 'smooth'
        })
      })
      return btn
    }

    slider.prepend(makeArrow('prev'))
    slider.append(makeArrow('next'))

    // Dots de pagination (mobile/tablette) : une puce par vignette, reflète la position
    // de scroll et y défile au clic. Masqués en desktop (≥lg) par le CSS — les flèches
    // prennent le relais. Enrichissement progressif : sans JS, le scroll tactile suffit.
    const items = Array.from(track.querySelectorAll('.cat-ov-item'))
    if (items.length > 1) {
      const dotsWrap = document.createElement('div')
      dotsWrap.className = 'cat-ov-dots'
      dotsWrap.setAttribute('aria-label', 'Pagination des vignettes')

      const dots = items.map((item, i) => {
        const dot = document.createElement('button')
        dot.type = 'button'
        dot.className = 'cat-ov-dot'
        dot.setAttribute('aria-label', `Aller à la vignette ${i + 1}`)
        dot.addEventListener('click', () => {
          track.scrollBy({
            left: item.getBoundingClientRect().left - track.getBoundingClientRect().left,
            behavior: 'smooth'
          })
        })
        dotsWrap.append(dot)
        return dot
      })
      slider.append(dotsWrap)

      // Puce active = vignette dont le bord gauche est le plus proche de celui du track.
      let raf = null
      let currentIndex = 0
      const syncActive = () => {
        raf = null
        const trackLeft = track.getBoundingClientRect().left
        let active = 0
        let best = Infinity
        items.forEach((item, i) => {
          const d = Math.abs(item.getBoundingClientRect().left - trackLeft)
          if (d < best) {
            best = d
            active = i
          }
        })
        // Fin de course : la dernière vignette ne peut pas atteindre le bord gauche
        // (scroll borné) → on force la dernière puce active quand le track est à fond.
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) {
          active = items.length - 1
        }
        currentIndex = active
        dots.forEach((dot, i) => {
          const on = i === active
          dot.classList.toggle('is-active', on)
          if (on) {
            dot.setAttribute('aria-current', 'true')
          } else {
            dot.removeAttribute('aria-current')
          }
        })
      }
      track.addEventListener('scroll', () => {
        if (raf === null) {
          raf = requestAnimationFrame(syncActive)
        }
      }, {
        passive: true
      })
      syncActive()

      // Autoplay (mobile/tablette < lg uniquement, hors prefers-reduced-motion) : avance
      // d'une vignette toutes les 4s et boucle à la fin. Pause dès que l'utilisateur agit
      // (tap/clic/molette) puis reprend après 5s d'inactivité. Ne tourne que lorsque la
      // section est visible à l'écran (économie + pas de saut à l'arrivée).
      const mqAuto = window.matchMedia('(max-width: 991.98px)')
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
      let autoTimer = null
      let resumeTimer = null
      let isVisible = true

      const goTo = (i) => {
        const item = items[i]
        if (!item) {
          return
        }
        track.scrollBy({
          left: item.getBoundingClientRect().left - track.getBoundingClientRect().left,
          behavior: 'smooth'
        })
      }
      const tick = () => {
        goTo(currentIndex >= items.length - 1 ? 0 : currentIndex + 1)
      }
      const startAuto = () => {
        if (autoTimer || !mqAuto.matches || reduceMotion.matches || !isVisible) {
          return
        }
        autoTimer = setInterval(tick, 4000)
      }
      const stopAuto = () => {
        if (autoTimer) {
          clearInterval(autoTimer)
          autoTimer = null
        }
      }
      // Interaction utilisateur : pause immédiate puis reprise différée. On écoute
      // pointerdown/wheel (déclenchés par l'utilisateur, jamais par le scroll programmatique)
      // pour ne pas que l'autoplay s'auto-coupe via l'événement scroll qu'il génère.
      const pauseThenResume = () => {
        stopAuto()
        if (resumeTimer) {
          clearTimeout(resumeTimer)
        }
        resumeTimer = setTimeout(startAuto, 5000)
      }
      slider.addEventListener('pointerdown', pauseThenResume)
      track.addEventListener('wheel', pauseThenResume, {
        passive: true
      })
      mqAuto.addEventListener('change', () => {
        stopAuto()
        startAuto()
      })

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          isVisible = entries[0].isIntersecting
          if (isVisible) {
            startAuto()
          } else {
            stopAuto()
          }
        }, {
          threshold: 0.4
        })
        io.observe(slider)
      } else {
        startAuto()
      }
    }
  })
}

// === Filtres du portfolio #realisations : chips → grille bento ===
// Chaque chip .pf-chip porte data-pf-filter (slug asr_category, ou '*' pour « Tout ») ; chaque
// item .pf-item porte data-pf-cat (slug de sa catégorie). Au clic : on bascule l'état actif
// (.on + aria-pressed), on masque les <li> hors-catégorie via .d-none (utilitaire Bootstrap :
// display:none !important — neutralise le .d-flex !important posé sur les <li> par posts.twig)
// et on pose .is-filtered sur la grille (cellules uniformes ; « Tout » restaure le bento positionnel).
// Enrichissement progressif : sans JS, les chips sont inertes et la grille complète s'affiche.
function initPfFilters() {
  document.querySelectorAll('.pf-section').forEach((section) => {
    const chips = section.querySelectorAll('.pf-chip')
    const grid = section.querySelector('.portfolio')
    if (!chips.length || !grid) {
      return
    }
    const items = Array.from(grid.children) // les <li> de la grille
    const catOf = (li) => {
      const item = li.querySelector('.pf-item')
      return item ? item.dataset.pfCat || '' : ''
    }

    // « Tout » : toutes les réalisations sont chargées, mais la vitrine est limitée aux 8 plus récentes
    // par le CSS (.portfolio:not(.is-filtered) > li:nth-child(n+9)) ; ici on retire juste tout masquage.
    // Filtré : on masque les <li> hors-catégorie via .d-none (bat le .d-flex !important du <li>).
    const apply = (filter) => {
      const all = filter === '*'
      grid.classList.toggle('is-filtered', !all)
      items.forEach((li) => {
        li.classList.toggle('d-none', !all && catOf(li) !== filter)
      })
    }

    // Masque les chips de catégorie sans aucune réalisation chargée → pas de filtre « mort ».
    chips.forEach((chip) => {
      const f = chip.dataset.pfFilter
      if (f && f !== '*' && !items.some((li) => catOf(li) === f)) {
        chip.classList.add('d-none')
      }
    })

    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        chips.forEach((other) => {
          other.classList.remove('on')
          other.setAttribute('aria-pressed', 'false')
        })
        chip.classList.add('on')
        chip.setAttribute('aria-pressed', 'true')
        apply(chip.dataset.pfFilter || '*')
      })
    })
  })
}

function initHome() {
  initCatOvSlider()
  initPfFilters()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHome)
} else {
  initHome()
}
